// extracted by mini-css-extract-plugin
export default {"container":"error-page_container__I5JvV","text":"error-page_text__e6yZ8","textCenter":"error-page_textCenter__x-WX9","buttonBlock":"error-page_buttonBlock__iMZG-"};